import { Injectable, Inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpResponse, HttpHeaders } from '@angular/common/http';
import { finalize, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '@env/environment';

@Injectable()

export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        @Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {}

    accessToken: string | null = null;

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let baseUrl = (request.url.substring(0, request.url.indexOf('.com')) + '.com');

        const rawOktaToken = localStorage.getItem('okta-token-storage');
        const oktaToken = rawOktaToken ? JSON.parse(rawOktaToken) : null;

        // The token-storage object can exist before/while the access token is
        // populated (e.g. during the login callback). Read defensively so a
        // missing access token never throws and breaks every request.
        this.accessToken = oktaToken?.accessToken?.accessToken ?? null;

        if (baseUrl == environment.oktaApiBaseUrl && this.accessToken) {
            request = request.clone({ 
                headers: request.headers.set('Authorization', 'Bearer ' + this.accessToken)
            });
        }

        return next.handle(request).pipe(
            catchError(err => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 403) {
                        console.log('Error 403:', err.error);
                        localStorage.clear();
                        this.oktaAuth.signOut({ postLogoutRedirectUri: environment.redirectUrl });
                        return throwError(() => err);
                    } else if (err.status === 400) {
                        console.log('Error 400:', err.error);
                        return throwError(() => err);
                    } else if (err.status === 500) {
                        console.log('Error 500:', err.error);
                        return throwError(() => err);
                    } else if (err.status === 405) {
                        console.log('Error 405:', err.error);
                        return throwError(() => err);
                    } else if (err.status === 404) {
                        console.log('Error 404:', err.error);
                        return throwError(() => err);
                    }
                }
                // Default case: handle non-HttpErrorResponse errors or unhandled status codes
                return throwError(() => err);
            }));           
        
    }

}

